import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import LinkText from 'core/components/link-text'

const StyledLink = styled.a`
  text-decoration: none;
`

const ExternalLink = ({ linkText, linkTextProps, to, ...restProps }) => (
  <StyledLink
    href={to}
    target='_blank'
    rel='noopener noreferrer'
    {...restProps}
  >
    <LinkText {...linkTextProps}>
      {linkText}
    </LinkText>
  </StyledLink>
)

ExternalLink.propTypes = {
  linkText: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  linkTextProps: PropTypes.object,
  to: PropTypes.string.isRequired
}

export default ExternalLink
